import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TrackingPageCoreService } from 'app/core/tracking-page';
import { isTruthy } from 'app/helpers';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { StorageService } from 'app/core';
import { TrackingPageFacade } from '../../store/tracking-page';

@Component({
  selector: 'app-tracking-page-search-page',
  templateUrl: './tracking-page-search.component.html'
})
export class TrackingPageSearchPageComponent implements OnInit {
  readonly trackingPage$: Observable<any>;
  readonly trackingPageLoaded$: Observable<boolean>;
  readonly noTrackingNumber$: Observable<string | boolean>;
  readonly noNumber$ = new BehaviorSubject(false);

  subdomain: string;
  search: FormControl;

  mode$ = new Subject();
  showedThemeImport = false;

  constructor(
    private translate: TranslateService,
    private trackingPage: TrackingPageFacade,
    private storageService: StorageService,
    private trackingPageCore: TrackingPageCoreService
  ) {
    this.trackingPageLoaded$ = trackingPage.trackingPageLoaded$;
    this.noTrackingNumber$ = trackingPage.noTrackingNumberFound$;
    this.trackingPage$ = trackingPage.trackingPage$.pipe(
      filter(isTruthy),
      tap(trackingPageModel =>
        this.trackingPageCore.loadFonts(trackingPageModel)
      )
    );
  }

  changeLanguage(id: string) {
    this.storageService.setItem('selectedLocale', id);
    this.translate.use(id);
    this.backToSearch();
  }

  searchNumber(searchText) {
    if (!searchText) {
      return;
    }

    this.trackingPage.findTrackingPageNumber({
      subdomain: this.subdomain,
      searchText,
      locale: this.storageService.getItem('selectedLocale')
    });
  }

  ngOnInit() {
    this.subdomain = this.trackingPageCore.getDomain();
    this.trackingPage.fetchTrackingPageBySubdomain(
      this.subdomain,
      this.storageService.getItem('selectedLocale')
    );
    this.search = new FormControl('');
    this.mode$.next('desktop');
  }

  backToSearch() {
    this.search.setValue('', { emitEvent: false });
    this.trackingPage.backToSearch();
  }

  changeMode(mode) {
    this.mode$.next(mode);
  }
}
